export const QUIZ_RETURN_TO_QUERY = 'returnTo';

const GOAL_TEST_SERIES_PATH_PATTERN = /^\/goal\/[^/]+\/[^/]+\/test-series$/;

export const appendQuizReturnTo = (href, returnPath) => {
  if (!href || !returnPath) {
    return href;
  }

  const separator = href.includes('?') ? '&' : '?';

  return `${href}${separator}${QUIZ_RETURN_TO_QUERY}=${encodeURIComponent(
    returnPath
  )}`;
};

export const getSafeGoalTestSeriesReturnPath = (returnTo) => {
  const value = Array.isArray(returnTo) ? returnTo[0] : returnTo;

  if (!value || typeof value !== 'string') {
    return null;
  }

  try {
    const decoded = decodeURIComponent(value);
    const [pathname] = decoded.split('?');

    if (GOAL_TEST_SERIES_PATH_PATTERN.test(pathname)) {
      return decoded;
    }
  } catch {
    return null;
  }

  return null;
};
